import React from "react";
import PropTypes from "prop-types";
import PublicationLinks from "../../../../../components/Publications/components/PublicationLinks";
import SortableHeader from "../../../../../components/atoms/SortableHeader";
import Expander from "../../../../../components/Expander";
import TextExpander from "../../../../../components/TextExpander";
import { labels, inProgress, active } from "./constants";
import { sortRefs } from "../../../../../common/helpers/sortingHelpers";

const sortByStartDate = (a, b) => {
  return new Date(b.start_date) - new Date(a.start_date);
};
const sortByCompletiontDate = (a, b) => {
  return new Date(b.completion_date) - new Date(a.completion_date);
};
const sortByTitle = (a, b) => {
  const x = a.title;
  const y = b.title;
  if (x === "" || x === null) return 1;
  if (y === "" || y === null) return -1;
  if (x === y) return 0;
  return x < y ? -1 : 1;
};
const sortByStatus = (a, b) => {
  const x = a.status;
  const y = b.status;
  if (x === "" || x === null) return 1;
  if (y === "" || y === null) return -1;
  if (x === y) return 0;
  return x < y ? -1 : 1;
};
const sortBySource = (a, b) => {
  const x = a.source;
  const y = b.source;
  if (x === "" || x === null) return 1;
  if (y === "" || y === null) return -1;
  if (x === y) return 0;
  return x < y ? -1 : 1;
};

const sortByLocations = (a = [], b = []) => {
  const aRefs = a.facilities || [];
  const bRefs = b.facilities || [];
  const x = aRefs[0] ? aRefs[0].country : "";
  const y = bRefs[0] ? bRefs[0].country : "";
  if (x === "" || x === null) return 1;
  if (y === "" || y === null) return -1;
  if (x === y) return 0;
  return x < y ? -1 : 1;
};
const sortByIntervetions = (a = [], b = []) => {
  const aRefs = a.interventions || [];
  const bRefs = b.interventions || [];
  const x = aRefs[0] ? aRefs[0].drug || aRefs[0].name : "";
  const y = bRefs[0] ? bRefs[0].drug || bRefs[0].name : "";
  if (x === "" || x === null) return 1;
  if (y === "" || y === null) return -1;
  if (x === y) return 0;
  return x < y ? -1 : 1;
};
const sortByConditions = (a = [], b = []) => {
  const aConditions = a.conditions || "";
  const bConditions = b.conditions || "";
  const x = aConditions[0].toLowerCase().replace(/,/g, "") || "";
  const y = bConditions[0].toLowerCase().replace(/,/g, "") || "";
  if (x === "" || x === null) return 1;
  if (y === "" || y === null) return -1;
  if (x === y) return 0;
  return x < y ? -1 : 1;
};

const colorStatus = (status) => {
  if (inProgress.includes(status)) {
    return "#8be28b";
  }
  if (active.includes(status)) {
    return "#ffb347";
  }
  if (status === "Unknown status") {
    return "#c4c4cf";
  }
  return "#ff392e";
};

const displayInterventions = (itemInterventions) => {
  if (itemInterventions && itemInterventions.length !== 0) {
    return (
      <Expander showMore="2">
        {itemInterventions.map((intervention, i) => {
          if (intervention?.type === "Drug" && intervention?.drug) {
            return (
              <div key={i}>
                {intervention.drug && (
                  <>
                    <span className="tw-font-bold">{intervention.drug}</span>
                    {intervention.type && (
                      <span className="tw-ml-1">{intervention.type}</span>
                    )}
                    {intervention?.description && (
                      <div>
                        <span className="tw-italic">
                          <TextExpander
                            text={intervention.description}
                            truncate="100"
                          />
                        </span>
                      </div>
                    )}
                  </>
                )}
              </div>
            );
          }
          if (intervention?.type !== "Drug" && intervention?.name) {
            return (
              <div key={`${intervention.name}-${i}`}>
                {intervention.name && (
                  <>
                    <span className="tw-font-bold">{intervention.name}</span>
                    {intervention.type && (
                      <span className="tw-ml-1">{intervention.type}</span>
                    )}
                    {intervention?.description && (
                      <div>
                        <span className="tw-italic">
                          <TextExpander
                            text={intervention.description}
                            truncate="100"
                          />
                        </span>
                      </div>
                    )}
                  </>
                )}
              </div>
            );
          }
          return null;
        })}
      </Expander>
    );
  }
  return "-";
};

function AACTTable({ items, sortedField, isAsc, toggleField }) {
  return (
    <div className="tw-overflow-y-auto tw-ml-0 tw-mb-8">
      <table className="varsome-table-overflow varsome-table-sorted">
        <thead>
          <tr>
            <SortableHeader
              sort={(key) => toggleField(sortByStartDate, key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="start_date"
              width="8%"
            />
            <SortableHeader
              sort={(key) => toggleField(sortByCompletiontDate, key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="completion_date"
              width="8%"
            />
            <SortableHeader
              sort={(key) => toggleField(sortByStatus, key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="status"
              width="7%"
            />
            <SortableHeader
              sort={(key) => toggleField(sortBySource, key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="source"
              width="9%"
            />
            <SortableHeader
              sort={(key) => toggleField(sortByTitle, key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="title"
              width="17%"
            />
            <SortableHeader
              sort={(key) => toggleField(sortByConditions, key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="conditions"
              width="12%"
            />
            <SortableHeader
              sort={(key) => toggleField(sortByIntervetions, key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="interventions"
              width="14%"
            />
            <SortableHeader
              sort={(key) => toggleField(sortByLocations, key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="facilities"
              width="16%"
            />
            <SortableHeader
              sort={(key) => toggleField(sortRefs, key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="pub_med_references"
              width="9%"
            />
          </tr>
        </thead>
        <tbody>
          {items.map((item, m) => {
            const nctUrl = `https://clinicaltrials.gov/ct2/show/${item.nct_id}`;
            const statusColor = colorStatus(item.status);
            let itemPhenotypes;
            if (item.phenotypes) {
              itemPhenotypes = Array.isArray(item.phenotypes)
                ? item.phenotypes.join(", ")
                : item.phenotypes;
            }
            let itemInterventions;
            if (item.interventions) {
              itemInterventions = item.interventions.filter(
                (intervention) => intervention.drug || intervention.name
              );
            }
            return (
              <tr key={`${m}-${new Date().getTime()}`}>
                <td>{item.start_date ? item.start_date : "-"}</td>
                <td>{item.completion_date ? item.completion_date : "-"}</td>
                <td className="tw-font-bold" style={{ color: statusColor }}>
                  {item.status ? item.status : "-"}
                </td>
                <td>{item.source || "-"}</td>
                <td>
                  {item.title ? (
                    <a target="_blank" href={nctUrl}>
                      {item.title}
                    </a>
                  ) : (
                    "-"
                  )}
                </td>
                <td>
                  <small>
                    <b>Conditions</b>
                  </small>
                  {item.conditions && Array.isArray(item.conditions) ? (
                    <Expander showMore="5">
                      {item.conditions.map((condition, i) => {
                        return (
                          <div key={`${condition}-${i}`}>
                            <span>{condition}</span>
                          </div>
                        );
                      })}
                    </Expander>
                  ) : (
                    "-"
                  )}
                  <small>
                    <b>Phenotypes</b>
                  </small>
                  <div>{itemPhenotypes || "-"}</div>
                </td>
                <td>{displayInterventions(itemInterventions)}</td>
                <td>
                  {item.facilities && item.facilities.length !== 0 ? (
                    <Expander showMore="3">
                      {item.facilities.map((facility, i) => {
                        const color = facility.status
                          ? colorStatus(facility.status)
                          : "";
                        return (
                          <div key={i}>
                            <b>
                              {facility.country ? `${facility.country}, ` : ""}
                            </b>

                            {facility.city ? `${facility.city}` : ""}
                            {facility.state ? `, ${facility.state}` : ""}
                            <br />
                            {facility.name ? `${facility.name} ` : ""}
                            <br />
                            {facility.status ? (
                              <span
                                style={{
                                  fontWeight: "bold",
                                  color,
                                }}
                              >
                                {facility.status}{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        );
                      })}
                    </Expander>
                  ) : (
                    "-"
                  )}
                </td>
                <td className="varsome-text-center">
                  {item.pub_med_references ? (
                    <PublicationLinks limit={5} ids={item.pub_med_references} />
                  ) : (
                    "-"
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

AACTTable.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      calculated_values: PropTypes.arrayOf(PropTypes.shape({})),
      conditions: PropTypes.arrayOf(PropTypes.string),
      designs: PropTypes.arrayOf(PropTypes.shape({})),
      eligibilities: PropTypes.arrayOf(PropTypes.shape({})),
      facilities: PropTypes.arrayOf(
        PropTypes.shape({
          city: PropTypes.string,
          country: PropTypes.string,
          name: PropTypes.string,
          state: PropTypes.string,
        })
      ),
      genes: PropTypes.arrayOf(PropTypes.string),
      interventions: PropTypes.arrayOf(PropTypes.shape({})),
      is_fda_drug: PropTypes.bool,
      nct_id: PropTypes.string,
      outcomes: PropTypes.arrayOf(
        PropTypes.shape({
          description: PropTypes.string,
          outcome_type: PropTypes.string,
          param_type: PropTypes.string,
          population: PropTypes.string,
          time_frame: PropTypes.string,
          title: PropTypes.string,
          units: PropTypes.string,
        })
      ),
      overall_officials: PropTypes.arrayOf(PropTypes.shape({})),
      phenotypes: PropTypes.arrayOf(PropTypes.string),
      population: PropTypes.string,
      // eslint-disable-next-line react/forbid-prop-types
      pub_med_references: PropTypes.arrayOf(PropTypes.any),
      source: PropTypes.string,
      sponsors: PropTypes.arrayOf(PropTypes.shape({})),
      status: PropTypes.string,
      title: PropTypes.string,
      unidentified_keywords: PropTypes.arrayOf(PropTypes.string),
    })
  ),
  sortedField: PropTypes.string,
  isAsc: PropTypes.bool,
  toggleField: PropTypes.func.isRequired,
};

AACTTable.defaultProps = {
  items: [],
  sortedField: null,
  isAsc: true,
};

export default AACTTable;
